import styled from "@emotion/styled";
import { mainColors } from "src/assets/colors";

export const TableData = styled('td', { label: 'TableData' })<{ isLessThanZero: boolean }>`
    color: ${(props): string => props.isLessThanZero ? mainColors.status.error : ""};
`;
